<!-- eslint-disable vue/no-parsing-error -->
<template>
        <div class="courses" v-if="dataLoaded && stuffCountriesLoaded">
            <template v-if="true">
                <div class="new-and-filter">
                    <h3>{{ $t('studentsTable.MANAGE_PARTICIPANTS') }}</h3>
                    <div class="new-and-filter__btns">
                        <div class="dropdown dropdown__certificate" ref="certificate__filter">
                            <input type="checkbox" id="certificate__filter">
                            <label class="dropdown__face" for="certificate__filter">
                                {{
                                    params.canCertificate === true ? $t('studentsTable.CERTIFIED')
                                    : params.canCertificate === false ? $t('studentsTable.NOT_CERTIFIED')
                                    : $t('studentsTable.ALL_CERTIFICATES')
                                }}
                                <span class="material-icons">keyboard_arrow_down</span>
                            </label>
                            <ul class="dropdown__items">    
                                <li @click="params.page = 0; params.canCertificate = true; handleCertificate()">{{ $t('studentsTable.CERTIFIED') }}</li>
                                <li @click="params.page = 0; params.canCertificate = false; handleCertificate()">{{ $t('studentsTable.NOT_CERTIFIED') }}</li>
                                <li @click="params.page = 0; params.canCertificate = '' ; handleCertificate()">{{ $t('studentsTable.ALL_CERTIFICATES') }}</li>
                            </ul>
                        </div>
                        <div class="dropdown" ref="status__filter">
                            <input type="checkbox" id="status__filter">
                            <label class="dropdown__face" for="status__filter">
                                {{
                                    params.status === '' ? $t('studentsTable.STATUS')
                                    : $t(`management.course.${Object.keys(statuses).find(propiedad => statuses[propiedad] === params.status)}`)
                                }}
                                <span class="material-icons">keyboard_arrow_down</span>
                            </label>
                            <ul class="dropdown__items">    
                                <li @click="params.page = 0; params.status = 0; handleStatus()">{{ $t('management.course.Active') }}</li>
                                <li @click="params.page = 0; params.status = 1; handleStatus()">{{ $t('management.course.Inactive') }}</li>
                                <li @click="params.page = 0; params.status = 2; handleStatus()">{{ $t('management.course.Finished') }}</li>
                                <li @click="params.page = 0; params.status = ''; handleStatus()">{{ $t('management.course.All') }}</li>
                            </ul>
                        </div>
                        <form @submit.prevent="params.page = 0; getStudents()">
                            <label class="new-and-filter__search" for="search">
                                <input type="text" :placeholder="$t('studentsTable.SEARCH_PLACEHOLDER')" id="search" name="search" v-model="params.search" />
                                <i @click="params.page = 0; getStudents()" class="material-icons-outlined">search</i>
                            </label>
                        </form>
                    </div>
                </div>
                <div v-if="tableAt === 'courses'" class="cohorte_data">
                    <span>{{ $t('studentsTable.COURSE') }}: <strong>{{participants[0]?.course}}</strong></span>
                    <button @mouseover="tooltipAddParticipant = true" @mouseleave="tooltipAddParticipant = false" 
                        :disabled="route.query.canBeManaged == 'false'" @click="modalAddStudent.active = true" class="create-new"><i class="material-icons">add_circle</i>{{ $t('studentsTable.ADD_NEW_PARTICIPANT') }}
                        <Tooltip v-if="tooltipAddParticipant && route.query.canBeManaged == 'false'" message="Esta acción debe ser realizada desde el Sistema de Gestión" color="black" />
                    </button>
                </div>
                
                <div ref="table" class="table-pagination">
                    <div class="table__container">
                        <table class="table">
                            <thead class="table__head">
                                <tr class="table__head__row">
                                    <th class="table__head__row__title">{{ $t('studentsTable.PARTICIPANT') }}</th>
                                    <th class="table__head__row__mail">{{ $t('studentsTable.MAIL') }}</th>
                                    <th class="table__head__row__phone">{{ $t('studentsTable.PHONE') }}</th>
                                    <th class="table__head__row__date">{{ $t('studentsTable.LAST_ACCESS') }}</th>
                                    <th class="table__head__row__certification">{{ $t('studentsTable.CERTIFIED') }}</th>
                                    <th class="table__head__row__status">{{ $t('studentsTable.STATUS') }}</th>
                                    <th class="table__head__row__date">{{ $t('studentsTable.LAST_INTERACTION') }}</th>
                                    <th class="table__head__row__options"></th>
                                    <div></div>
                                </tr>
                            </thead>
                            <tbody class="table__body">
                                <tr class="table__body__row" v-for="(row, index) in participants" :key="index">
                                    <td class="table__body__row__title">
                                        {{ row.fullName || '-' }}
                                    </td>

                                    <td class="table__body__row__mail" @mouseleave="row.emailTooltip = false">
                                        <div>
                                            <span @mouseover="row.emailTooltip = true && row.email.length > 25">{{ row.email || '-' }}</span>
                                            <Tooltip v-if="row.emailTooltip" :message="row.email" styles="max-width:none; top: 0;"/>
                                            <i class="material-icons" @click.stop="copyToClipboard(row.email, 'Email')" style="cursor:pointer">content_copy</i>
                                        </div>
                                    </td>
                                    <td class="table__body__row__phone" @mouseleave="row.phoneTooltip = false">
                                        <div>
                                            <span @mouseover="row.phoneTooltip = true && row.phone.length > 16">{{ row.phone || '-' }}</span>
                                            <Tooltip v-if="row.phoneTooltip" :message="row.phone" styles="max-width:none; top: 0;"/>
                                            <i class="material-icons" @click.stop="copyToClipboard(row.phone, 'Teléfono')" style="cursor:pointer">content_copy</i>
                                        </div>
                                    </td>

                                    <td class="table__body__row__date">{{ row.lastLogin ? formatDate(row.lastLogin) : '-' }}</td>
                                    <td class="table__body__row__certification">
                                        {{ row.canCertificate ? $t('studentsTable.YES') : $t('studentsTable.NO') }}
                                        <i v-if="row.canCertificate && row.certificationForced" @mouseover="tooltipIndex = index" @mouseleave="tooltipIndex = null" class="material-icons-outlined tooltip-icon">info</i>
                                        <Tooltip v-if="tooltipIndex === index" :message="t('studentsTable.CERTIFICATION_FORCED_TOOLTIP', { email: row.certificationForcedEmail, date: formatDate(row.certificationForcedDate) })" />
            
                                    </td>
                                    <td class="table__body__row__status"><span :class="`--${row.status}`">{{
                                        $t(`management.course.${row.status}`) }}</span>
                                    </td>
                                    <td>{{ row.lastInteractionDate ? formatDate(row.lastInteractionDate) : '-' }}</td>
                                    <td class="table__body__row__options">
                                        <div v-if="route.query.canBeManaged != 'false'">
                                            <i class="material-icons" @click.stop="modalOptions == row.learningUserId ? modalOptions = null : modalOptions = row.learningUserId">more_vert</i>
                                        </div>
                                        <div v-else @mouseover="tooltipOptionsDisabled = true" @mouseleave="tooltipOptionsDisabled = false">
                                            <i class="material-icons" style="opacity: .3;">more_vert</i>
                                            <Tooltip v-if="tooltipOptionsDisabled" message="Las acciones deben ser realizadas desde el Sistema de Gestión" color="black" />
                                        </div>
                                    </td>
                                    <div class="table__modal-options" v-if="modalOptions == row.learningUserId" @click.stop="''">

                                        <template v-if="tableAt === 'courses'">
                                            <div :class="{ 'disabled': alterStateLoading }" v-if="row.status.toLowerCase() !== 'inactive'" @click="!alterStateLoading && alterState(row.learningUserId)"><i class="material-icons-outlined">cancel</i>{{ $t('studentsTable.UNSUBSCRIBE') }}</div>
                                            <div :class="{ 'disabled': alterStateLoading }" v-else @click.stop="!alterStateLoading && alterState(row.learningUserId)" ><i class="material-icons-outlined">check_circle_outline</i>{{ $t('studentsTable.SUBSCRIBE') }}</div>
                                            <div
                                            v-if="!row.canCertificate && !row.certificationForced"
                                            @click="(!certificateLoading && !row.canCertificate) && openCertifyModal(row.learningUserId, row.fullName)">
                                                <i class="material-icons-outlined">school</i> {{ $t('studentsTable.FORCE_CERTIFICATION') }}
                                            </div>
            
                                            <div
                                            v-if="row.canCertificate && row.certificationForced"
                                            @click="(!certificateLoading && row.canCertificate) && openUncertifyModal(row.learningUserId, row.fullName)">
                                                <i class="material-icons-outlined">undo</i> {{ $t('studentsTable.UNDO_CERTIFICATION') }}
                                            </div>
            
                                            <div @click="changeEmailModal[index] = true">
                                                <i class="material-icons-outlined">email</i> {{ $t('studentsTable.CHANGE_EMAIL') }}
                                            </div>
                                            <div @click="changePhoneModal[index] = true">
                                                <i class="material-icons-outlined">phone</i> {{ $t('studentsTable.CHANGE_PHONE') }}
                                            </div>
                                        </template>

                                        <template v-if="tableAt==='studentsActivityLog'">
                                            <div @click="router.push(`/interactions/${row.learningUserId}`)">
                                                <i class="material-icons-outlined">visibility</i>{{ $t('studentsTable.VIEW_INTERACTIONS') }}
                                            </div>
                                            <div v-if="false" @click="router.push({ name: 'students-activity-log-add', params: { courseId: row.courseId, learningUserId: row.learningUserId } })">
                                                <i class="material-icons-outlined">add_circle</i>{{ $t('studentsTable.ADD_NEW_INTERACTION') }}
                                            </div>
                                        </template>


                                    </div>
            
                                    <Modal v-if="changeEmailModal[index] === true" :isOpen="changeEmailModal[index] === true" @close="changeEmailModal[index] = false">
                                        <div class="modal-add-student">
                                            <h4>{{ $t('studentsTable.CHANGE_PARTICIPANT_EMAIL') }}</h4>
                                            <span>{{ $t('studentsTable.ENTER_NEW_EMAIL') }}</span>
                                            <Input 
                                                v-model="newEmail"
                                                :label="$t('studentsTable.EMAIL')"
                                                id="Email"
                                                :isError="newEmail.trim().length > 1 && v$.newEmail.email.$invalid"
                                                :errorMessage="$t('studentsTable.INVALID_EMAIL_FORMAT')"
                                                />
                                            <div class="buttons">
                                                <button @click.stop="changeEmailModal[index] = false; newEmail = ''"><i class="material-icons">arrow_back</i>{{ $t('studentsTable.BACK') }}</button>
                                                <button :disabled="v$.newEmail.email.$invalid || newEmail.trim().length < 1 || changeEmailSubmitting" @click.stop="changeEmail(row.learningUserId ,index)" >
                                                    {{ $t('global.CONTINUE') }}<i class="material-icons">arrow_forward</i>
                                                </button>
                                            </div>
                                        </div>
                                    </Modal>

                                    <Modal v-if="changePhoneModal[index] === true" :isOpen="changePhoneModal[index] === true" @close="changePhoneModal[index] = false">
                                        <div class="modal-add-student">
                                            <h4>{{ $t('studentsTable.CHANGE_PARTICIPANT_PHONE') }}</h4>
                                            <span v-if="row.phone">{{ $t('studentsTable.CURRENT_PHONE') }}: <strong>{{ row.phone }}</strong></span>
                                            <span>{{ $t('studentsTable.ENTER_NEW_PHONE') }}</span>
                                            <Input 
                                                v-model="newPhone"
                                                :label="$t('studentsTable.PHONE')"
                                                id="phone"
                                            />
                                            <div class="buttons">
                                                <button @click.stop="changePhoneModal[index] = false; newPhone = ''"><i class="material-icons">arrow_back</i>{{ $t('studentsTable.BACK') }}</button>
                                                <button :disabled="!newPhone || changePhoneSubmitting" @click.stop="changePhone(row.learningUserId ,index)" >
                                                    {{ $t('global.CONTINUE') }}<i class="material-icons">arrow_forward</i>
                                                </button>
                                            </div>
                                        </div>
                                    </Modal>
            
            
                                    <Modal :isOpen="certifyModal.active" @close="closeCertifyModal" class="modal-certificate">
                                        <div>
                                            <h4>
                                                {{ $t('studentsTable.FORCE_CERTIFICATION_PROMPT') }}<br/>
                                                <span class="modal-certificate__name">{{ certifyModal.userName }}</span> ?
                                            </h4>
                                            <div class="buttons">
                                                <button @click.stop="closeCertifyModal">{{ $t('studentsTable.CANCEL') }}</button>
                                                <button @click.stop="handleCertification">
                                                    <span>{{ $t('studentsTable.FORCE_CERTIFICATION') }}</span><i class="material-icons">arrow_forward</i>
                                                </button>
                                            </div>
                                        </div>
                                    </Modal>
            
                                    <Modal :isOpen="uncertifyModal.active" @close="closeUncertifyModal" class="modal-certificate">
                                        <div>
                                            <h4>
                                                {{ $t('studentsTable.UNDO_CERTIFICATION_PROMPT') }}<br/>
                                                <span class="modal-certificate__name">{{ uncertifyModal.userName }}</span> ?
                                            </h4>
                                            <div class="buttons">
                                                <button @click.stop="closeUncertifyModal">{{ $t('studentsTable.CANCEL') }}</button>
                                                <button @click.stop="handleUncertificate">
                                                    <span>{{ $t('studentsTable.UNDO_CERTIFICATION') }}</span><i class="material-icons">arrow_forward</i>
                                                </button>
                                            </div>
                                        </div>
                                    </Modal>
            
            
            
            
                                </tr>
                            </tbody>
                        </table>
                        <div className="management__noResults" v-if="!participants.length"
                            style="padding:20px 0 20px 0;text-align:center">
                            {{ $t('studentsTable.NO_RESULTS') }}
                        </div>
                    </div>
                    <div class="pagination" v-if="totalResults">
                        <button class="prev-next" @click.stop="selectPage('prev')" :disabled="params.page == 0"><i
                                class="material-icons">arrow_back</i><span>{{ $t('studentsTable.PREVIOUS') }}</span> </button>
                        <div class="page"><span>{{ formattedPage }}</span>{{ formattedPages }}</div>
                        <button class="prev-next" @click.stop="selectPage('next')"
                            :disabled="params.page + 1 == pages"><span>{{ $t('studentsTable.NEXT') }}</span> <i
                                class="material-icons">arrow_forward</i>
                        </button>
                    </div>
                </div>
            </template>


            <template v-if="tableAt === 'courses'">

                <Modal :isOpen="unsuscribeModal" @close="unsuscribeModal = false">
                    <div class="unsuscribeUser">
                        <h3>{{ $t('studentsTable.UNSUBSCRIBE_USER') }}</h3>
                        <span>{{ $t('studentsTable.PROCEED_UNSUBSCRIBE', { count: unsuscribeList.length }) }}</span>
                        <div class="pills">
                            <span class="pill" v-for="(participant, idx) in unsuscribeList" :key="idx">{{ participants.find(part => part.learningUserId === participant)?.fullName }}</span>
                        </div>
                        <div>
                            <h5>{{ $t('studentsTable.DECISION') }}</h5>
                            <Select 
                                mode="simple"
                                id="decision"
                                :values="[t('studentsTable.FORGE'), t('studentsTable.ON_PARTICIPANT_REQUEST')]"
                                :isDropdown="false"
                            />
                        </div>
        
                        <h5>{{ $t('studentsTable.REASON_FOR_UNSUBSCRIBE') }}</h5>
                        
                        <Select 
                            mode="simple"
                            id="motivo_baja"
                            :label="$t('studentsTable.REASON_FOR_UNSUBSCRIBE')"
                            :values="[t('studentsTable.LACK_OF_INTEREST'), t('studentsTable.PLATFORM_ISSUES'), t('studentsTable.NO_TIME_AVAILABLE'), t('studentsTable.OTHERS')]"
                            />

                        <Input 
                            :placeholder="$t('studentsTable.SPECIFY_REASON')"
                            :label="$t('studentsTable.SPECIFY_REASON')"
                            id="motivo_especifico"
                        />

                        <div class="unsuscribeUser__buttons">
                            <button @click="unsuscribeModal = false"><i class="material-icons-outlined">arrow_back</i>{{ $t('global.BACK') }}</button>
                            <button>{{ $t('global.CONTINUE') }} <i class="material-icons-outlined">arrow_forward</i></button>
                        </div>
                    </div>
                </Modal>

                <Modal :isOpen="modalMoveStudent" @close="modalMoveStudent = false">
                    <div class="moveStudent">
                        <h3 class="moveStudent__title">{{ $t('studentsTable.MOVE_PARTICIPANTS') }}</h3>
                        <div class="moveStudent__datas">
                            <div class="moveStudent__data">
                                <strong>{{ $t('studentsTable.COURSE') }}: </strong> {{ participants[0]?.course }}
                            </div>

                            <div class="moveStudent__data">
                                <strong>{{ $t('studentsTable.PARTICIPANTS') }}: </strong> {{ moveStudenList?.length }}
                            </div>
                        </div>

                        <Select 
                            mode="simple"
                            id="new_course"
                            :label="$t('studentsTable.SELECT_NEW_COURSE')"
                            :values="[1,2,3,4]"
                        />

                        <div style="margin-top: 42px;" class="unsuscribeUser__buttons">
                            <button @click="modalMoveStudent = false"><i class="material-icons-outlined">arrow_back</i>{{ $t('global.CONTINUE') }}</button>
                            <button>{{ $t('global.CONTINUE') }} <i class="material-icons-outlined">arrow_forward</i></button>
                        </div>
                    </div>
                </Modal>

                <Modal :isOpen="modalAddStudent.active" @close="() => modalAddStudent.active = false">
                    <div class="modal-add-student">
                        <h4>{{ $t('studentsTable.ADD_NEW_PARTICIPANT') }}</h4>
                        <span>{{ $t('studentsTable.ENTER_NEW_PARTICIPANT_EMAIL') }}</span>
                        <Input 
                            v-model="modalAddStudent.email"
                            :label="$t('studentsTable.EMAIL')"
                            id="Email"
                            :isError="v$.modalAddStudent.email.$invalid"
                            :errorMessage="$t('studentsTable.INVALID_EMAIL_FORMAT')"
                            />
                        <template v-if="modalAddStudent?.fullData">
                            <span>{{ $t('studentsTable.REQUIRED_FIELDS_FOR_PARTICIPANT') }}</span>
                            <Input 
                                v-model="modalAddStudent.firstName"
                                :label="$t('studentsTable.FIRST_NAME')"
                            />
                            <Input 
                                v-model="modalAddStudent.lastName"
                                :label="$t('studentsTable.LAST_NAME')"
                            />
                            <Select 
                                v-model="modalAddStudent.countryId"
                                :label="$t('studentsTable.COUNTRY')"
                                valueProp="id"
                                valueLabel="name"
                                :values="stuffCountries"
                                :isDropdown="true"
                            />
                        </template>
                        <div class="buttons">
                            <button @click.stop="modalAddStudent.active = null"><i class="material-icons">arrow_back</i>{{ $t('global.BACK') }}</button>
                            <button @click.stop="postStudent()" :disabled="postLoading || (Object.values(modalAddStudent).some(prop => { if (!prop) return true }) && modalAddStudent.fullData) || v$.modalAddStudent.email.$invalid">
                                {{ $t('global.CONTINUE') }}<i class="material-icons">arrow_forward</i>
                            </button>
                        </div>
                    </div>
                </Modal>
            </template>
        </div>
        <Loader v-else />
</template>

<script>
import { inject, onMounted, onBeforeUnmount, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/Modal.vue';
import Input from '@/components/Input.vue';
import Select from '@/components/Inputs/Select.vue';
import { email } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import Tooltip from '@/components/ToolTip.vue';
import { useI18n } from 'vue-i18n';



export default {
    props: {
        tableAt: {
            type: String,
            required: true
        }
    },
    components: {
        Loader,
        Modal,
        Input,
        Select,
        Tooltip
    },
    setup() {
        const store = useStore();
        const { t } = useI18n();
        const v$ = useVuelidate();
        const router = useRouter();
        const route = useRoute()
        const formatDate = inject('formatDate');
        const copyToClipboard = inject('copyToClipboard');
        const userData = computed(() => store.getters.manageUser_user);
        const stuffCountries = ref();
        const stuffCountriesLoaded = ref(false);
        const statusOptions = ['OPEN', 'CLOSED', 'FULL', 'PENDING_OPEN', 'ALL'];
        const modalOptions = ref(null)
        const participants = ref()
        const allSelected = ref(false)
        const unsuscribeList = ref([])
        const unsuscribeModal = ref()
        const modalMoveStudent = ref(false)
        const newEmail = ref('')
        const changeEmailModal = ref({})
        const changeEmailSubmitting = ref(false)
        const newPhone = ref('')
        const changePhoneModal = ref({})
        const changePhoneSubmitting = ref(false)
        const moveStudenList = ref([])
        const certificateLoading = ref(false)
        const uncertificateLoading = ref(false)
        const alterStateLoading = ref(false)
        const modalAddStudent = ref({
            active: false,
            fullData: false,
            email: '',
            firstName: '',
            lastName: '',
            countryId: null
        });
        watch(modalAddStudent.value, () => {
            if (!modalAddStudent.value.active) {
                modalAddStudent.value.fullData = false;
                modalAddStudent.value.email = '';
                modalAddStudent.value.firstName = '';
                modalAddStudent.value.lastName = '';
                modalAddStudent.value.countryId = null;
            }
        })
        const dataLoaded = ref(false);
        const modalStatusFilters = ref(false);
        const modalCountryFilters = ref(false);
        const modalCoordinatorFilters = ref(false);
        const stageTooltip = ref(null);
        const tooltipAddParticipant = ref(false);
        const tooltipOptionsDisabled = ref(false);
        const params = ref({
            page: 0,
            rows: 5,
            status: '',
            courseId: route.params.courseId,
            search: '',
            canCertificate: ''
        })
        const totalResults = ref();
        const remainResults = ref();
        const pages = ref();
        const tooltipIndex = ref(null);
        const postLoading = ref(false);

        const formattedPage = computed(() => {
            return 'Página ' + (params.value.page + 1 < 10 ? '0' + (params.value.page + 1) : params.value.page + 1);
        });

        const formattedPages = computed(() => {
            return ' / ' + (pages.value < 10 ? '0' + pages.value : pages.value);
        });


        const statuses = ref({
            Active: 0,
            Inactive: 1,
            Finished: 2,
            All: 3
        })

        const hiddenItems = (id) => {
            document.getElementById(id).checked = false
        }





        async function postStudent() {
            postLoading.value = true;
            try {
                modalAddStudent.value.courseId = route.params.courseId
                await store.dispatch('coursesInstances_addStudent', modalAddStudent.value);
                modalAddStudent.value.active = null;
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_PARTICIPANT_ADDED') });
                getStudents()
                postLoading.value = false;
            } catch (error) {
                postLoading.value = false;
                console.log(error);
                if (error.response.data == 'NEED_MANDATORY_FIELDS') {
                    modalAddStudent.value.fullData = true;
                    return;
                }
                if (error.response.data == 'USER_ALREADY_ADDED') {
                    modalAddStudent.value.active = null;
                    store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_USER_EXISTS') });
                    return;
                }
                else store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ADD_PARTICIPANT_ERROR') });
            }
        }

        const changeEmail = async (learningUserId, idx) => {
            if (changeEmailSubmitting.value) return
            try {
                changeEmailSubmitting.value = true
                let body = {
                    learningUserId,
                    email: newEmail.value
                }
                await store.dispatch('coursesInstances_alterEmail', body)
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_EMAIL_CHANGED') })
                newEmail.value = ''
                changeEmailModal.value[idx] = false
                getStudents()
            } catch (message) {
                if (message.response.data == 'EMAIL_ALREADY_EXISTS') {
                    store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_EMAIL_EXISTS') })
                } else {
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ERROR') })
                }
            } finally {
                changeEmailSubmitting.value = false
                newEmail.value = ''
            }
        }

        const changePhone = async (learningUserId, idx) => {
            if (changePhoneSubmitting.value) return
            try {
                changeEmailSubmitting.value = true
                let body = {
                    learningUserId,
                    value: newPhone.value
                }
                await store.dispatch('coursesInstances_changePhone', body)
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_PHONE_CHANGED') })
                newPhone.value = ''
                changePhoneModal.value[idx] = false
                getStudents()
            } catch (message) {
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ERROR_CHANGING_PHONE') })
            } finally {
                changePhoneSubmitting.value = false
                newPhone.value = ''
            }
        }

        const handleStatus = () => {
            hiddenItems('status__filter')
            params.value.page = 0
            getStudents()
        }

        const handleCertificate = () => {
            hiddenItems('certificate__filter')
            params.value.page = 0
            getStudents()
        }


        const certifyModal = ref({
            active: false,
            learningUserId: null,
            userName: ''
        });

        const uncertifyModal = ref({
            active: false,
            learningUserId: null,
            userName: ''
        });



        const openCertifyModal = (learningUserId, userName) => {
            certifyModal.value = {
                active: true,
                learningUserId,
                userName
            };
        };

        const openUncertifyModal = (learningUserId, userName) => {
            uncertifyModal.value = {
                active: true,
                learningUserId,
                userName
            };
        };


        const handleCertification = async () => {
            if (certifyModal.value.learningUserId) {
                try {
                    certificateLoading.value = true;
                    let body = {
                        courseId: route.params.courseId,
                        learningUserId: certifyModal.value.learningUserId
                    };
                    await store.dispatch('coursesInstances_certificate', body);
                    store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_CERTIFICATION_FORCED') });
                    getStudents(); // Refresh the students list
                } catch (err) {
                    console.log(err);
                    store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_CERTIFICATION_ERROR') });
                } finally {
                    certificateLoading.value = false;
                    closeCertifyModal();
                    modalOptions.value = null; // Close the options dropdown
                }
            }
        };


        const handleUncertificate = async () => {
            if (uncertifyModal.value.learningUserId) {
                try {
                    uncertificateLoading.value = true;
                    let body = {
                        courseId: route.params.courseId,
                        learningUserId: uncertifyModal.value.learningUserId
                    };
                    await store.dispatch('coursesInstances_uncertificate', body);
                    store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_CERTIFICATION_UNDONE') });
                    getStudents(); // Refresh the students list
                } catch (err) {
                    console.log(err);
                    store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_UNCERTIFICATION_ERROR') });
                } finally {
                    uncertificateLoading.value = false;
                    closeUncertifyModal(); // Close the modal after action
                    modalOptions.value = null; // Close the options dropdown
                }
            }
        };

        const closeCertifyModal = () => {
            certifyModal.value = {
                active: false,
                learningUserId: null
            };
        };

        const closeUncertifyModal = () => {
            uncertifyModal.value = {
                active: false,
                learningUserId: null
            };
        };


        const alterState = async (learninguser) => {
            if (alterStateLoading.value) return
            try {
                alterStateLoading.value = true
                let body = {
                    courseId: route.params.courseId,
                    learningUserId: learninguser
                }
                await store.dispatch('coursesInstances_alterState', body)
                getStudents()
            } catch (err) {
                console.log(err)
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ALTER_STATE_ERROR') })
            } finally {
                alterStateLoading.value = false
            }
        }

        async function getStuffCountries() {
            try {
                let req = await store.dispatch('stuff__countries');
                stuffCountries.value = req.data;
                stuffCountriesLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ERROR_LOADING_FILTERS') });
            }
        }

        async function getStudents() {
            try {
                dataLoaded.value = false;
                let req = await store.dispatch('coursesInstances_students', params.value);
                participants.value = req.data.data;
                participants.value = participants.value.map(part => ( { ...part, checked: false } ))
                totalResults.value = req.data.totalResults;
                remainResults.value = req.data.totalResults - (params.value.page * params.value.rows);
                pages.value = Math.ceil(req.data.totalResults / params.value.rows);
                dataLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ERROR_FETCHING_DATA') });
            }
        }

        async function getExcel(id, name) {
            try {
                await store.dispatch('preInscription_getExcel', { id: id, fileName: 'preinscripcion-' + name })
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ERROR_DOWNLOADING_FILE') });
            }
        }

        function selectPage(prevNext) {
            if (prevNext == 'next') params.value.page++;
            else if (prevNext == 'prev') params.value.page--;
            getStudents()
        }

        function selectStatus(option) {
            params.value.status = option;
            params.value.page = 0;
            getStudents();
            modalStatusFilters.value = false;
        }

        async function changeStatus(id) {
            try {
                modalOptions.value = null;
                await store.dispatch('preInscription_changeStatus', id);
                getStudents();
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('studentsTable.NOTIFICATION_ERROR_CHANGING_STATUS') });
            }
        }

        const togleAll = () => {
            allSelected.value = !allSelected.value
            participants.value.forEach(participant => participant.checked = allSelected.value)
        }

        const closeModalFilters = (e) => {
            if (!e.target.matches('.status-filters') && !e.target.matches('.modal-status-filters')) {
                modalStatusFilters.value = false;
            }
            if (!e.target.matches('.country-filters') && !e.target.matches('.modal-country-filters')) {
                modalCountryFilters.value = false;
            }
            if (!e.target.matches('.coordinator-filters') && !e.target.matches('.modal-coordinator-filters')) {
                modalCoordinatorFilters.value = false;
            }
        }
        const closeModalOptions = (e) => {
            if (!e.target.matches('.table__modal-options')) {
                modalOptions.value = null;
            }
        }

        onMounted(() => {
            getStudents();
            getStuffCountries();
            document.addEventListener('click', closeModalFilters);
            document.addEventListener('click', closeModalOptions);
            document.body.style.overflowX = 'auto';
            document.body.style.background = '#fff';
            //userData.value.role = 'ADMINISTRADOR'
        })
        onBeforeUnmount(() => {
            document.removeEventListener('click', closeModalFilters);
            document.removeEventListener('click', closeModalOptions);
            document.body.style.overflowX = 'visible';
            document.body.style.background = '';

        })

        return {
            router,
            route,
            formatDate,
            copyToClipboard,
            unsuscribeModal,
            togleAll,
            userData,
            statusOptions,
            modalAddStudent,
            dataLoaded,
            stuffCountries,
            stuffCountriesLoaded,
            modalOptions,
            modalStatusFilters,
            modalCountryFilters,
            modalCoordinatorFilters,
            stageTooltip,
            tooltipAddParticipant,
            tooltipOptionsDisabled,
            getStudents,
            pages,
            moveStudenList,
            params,
            totalResults,
            selectPage,
            selectStatus,
            changeStatus,
            getExcel, 
            participants,
            v$,
            postStudent,
            unsuscribeList,
            allSelected,
            modalMoveStudent,
            statuses,
            hiddenItems,
            handleStatus,
            handleCertificate,
            handleUncertificate,
            certifyModal,
            openCertifyModal,
            closeCertifyModal,
            uncertifyModal,
            openUncertifyModal,
            closeUncertifyModal,
            handleCertification,
            alterState,
            alterStateLoading,
            certificateLoading,
            newEmail,
            changeEmail,
            changeEmailModal,
            changeEmailSubmitting,
            newPhone,
            changePhone,
            changePhoneModal,
            changePhoneSubmitting,
            tooltipIndex,
            formattedPage,
            formattedPages,
            postLoading
        }
    },
    validations() {
        return {
            modalAddStudent: {
                email: { email }
            },
            newEmail: { email }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.disabled{
    opacity: .6;
    cursor: default !important;
}

.selected__actions{
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    justify-content: flex-end;
    height: 37px;
    button{
        border: 1px solid $green;
        border-radius: 44px;
        font-size: 16px;
        font-weight: 600;
        color: $green;
        padding: 8px 0;
        min-width: 149px;
        &:disabled{
            cursor: default;
        }
    }
}

.dropdown{
    &__certificate{
        width: 200px;
    }
    &__items{
        padding: 8px 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        background: #fff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        z-index: 2;
        font-size: 13px;
        font-weight: 600;
        border: none;
        li{
            padding: 4px 24px;
            cursor: pointer;
            &:hover{
                background: rgba(189, 228, 228, 0.5);
            }
        }
        @media screen and (max-width: 750px) {
            right: 0 !important;
        }
    }
}

.moveStudent{
    width: 100%;
    max-width: 460px;
    padding: 28px 40px;
    display: flex;
    flex-direction: column;
    gap: 28px;
    &__title{
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
    }
    &__datas{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }
    &__data{
        font-size: 12px;
        font-weight: 400;
        strong{
            font-weight: 700;
        }
    }
}

.table__modal-options {
    position: absolute;
    top: 50px;
    right: 2px;
    min-width: 215px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    padding: 6px 0;
    >div {
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 22px;
        &:hover {
            background: rgba(189, 228, 228, 0.5);
        }
    }
}

/* .modal-options{
    //position: absolute;
    //top: 100px;
    //right: 100px;
    padding: 22px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 5000;
    margin-bottom: 10px;
    >div{
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        &:hover{
            background: rgba(189, 228, 228, 0.5);
        }
    }
} */

.management {
    &__noResults {
        display: grid;
        padding: 20px 0 20px 0;
        text-align: center;
        grid-column-start: 1;
        grid-column-end: 7;
    }

}

.create-new {
    margin-right: 8px;
    color: $green;
    font-weight: 600;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    .material-icons {
        font-size: 15px;
    }
}

.cohorte_data{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    >span{
        font-size: 18px;
        font-weight: 400;
        strong{
            font-weight: 400;
            color: $green;
        }
    }
}
.modal__inner{
    max-width: 420px;
}

.modal-add-student{
    position: relative;
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    border-radius: 10px;
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h4{
        padding-bottom: 4px;
        margin-top: -6px;
        font-weight: 700;
        font-size: 16px;
    }
    span{
        font-weight: 400;
        font-size: 13px;
    }
    .buttons{
        display: flex;
        justify-content: center;
        gap: 24px;
        padding-top: 16px;
        button{
            width: 152px;
            padding: 8px 0;
            @include icon-and-text-container;
            justify-content: center;
            border-radius: 44px;
            font-weight: 600;
            font-size: 16px;
            &:first-child{
                border: 1px solid $green;
                color: $green;
            }
            &:last-child{
                background: $green;
                color: #fff;
            }
        }
    }
}


.modal-certificate {

    .modal__inner {
        max-width: unset;
    }
    
    &__name {
        font-style: italic;
        color: $green;
        text-transform: capitalize;
        font-weight: 700;
    }
    .close{
        position: absolute;
        top: 16px;
        right: 16px;
        cursor: pointer;
    }
    h4{
        padding-bottom: 4px;
        font-size: 16px;
        text-align: center;
        font-weight: 400;
    }
    
    .buttons{
        display: flex;
        justify-content: center;
        gap: 8px;
        padding-top: 16px;
        button{
            min-width: 152px;
            padding: 8px 16px;
            @include icon-and-text-container;
            justify-content: center;
            border-radius: 44px;
            font-weight: 600;
            font-size: 16px;
            &:first-child{
                border: 1px solid $green;
                color: $green;
            }
            &:last-child{
                background: $green;
                color: #fff;
            }
        }
    }
}

.pills{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    .pill{
        padding: 6px 10px 6px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
        font-size: 13px;
        background-color: $whitegray;
        border: 1px solid #000;
        border-radius: 50px;
        min-width: 150px;
        gap: 12px;
        .material-icons-outlined{
            font-size: 16px;
            cursor: pointer;
        }
    }
}

.courses {
    width: fit-content;
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    h1 {
        font-size: 25px;
        font-weight: 700;
    }

    .tabs {
        display: flex;
        margin: 30px 0;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);

        >div {
            height: 60px;
            width: 180px;
            @include flex-column;
            justify-content: center;
            font-size: 15px;
            font-weight: 600;

            &.--selected {
                color: $green;
                border-bottom: 2px solid $green;
            }
        }
    }

    .new-and-filter {
        position: relative;
        min-height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__search{
            input{
                border: none;
                &::placeholder{
                    font-size: 12px;
                }
            }
            border: 1px solid $black;
            padding: 6px 18px;
            border-radius: 999px;
            display: flex;
            align-items: center;
            .material-icons-outlined{
                position: absolute;
                font-size: 14px;
                right: 18px;
            }
        }
        h3 {
            font-size: 20px;
        }

        &__btns {
            display: flex;
            gap: 16px;
            align-items: center;
            @media screen and (max-width: 750px) {
                @include flex-column;
                padding-bottom: 16px;
            }

            button {
                @include icon-and-text-container;
                font-size: 12px;
                &.open-filters {
                    border: 1px solid;
                    border-radius: 16px;
                    padding: 6px 18px;
                    font-weight: 400;
                    gap: 18px;
                    height: fit-content;

                    .material-icons {
                        font-size: 18px;
                    }
                }
            }
        }

        .modal-filters {
            position: absolute;
            top: 50px;
            padding: 8px 0;
            display: flex;
            flex-direction: column;
            gap: 6px;
            background: #fff;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 10px;
            z-index: 2;
            font-size: 13px;
            font-weight: 600;

            div {
                padding: 4px 24px;
                cursor: pointer;

                &:hover {
                    background: rgba(189, 228, 228, 0.5);
                }
            }

            @media screen and (max-width: 750px) {
                right: 0 !important;
            }
        }

        .modal-country-filters {
            right: 126px;
        }

        .modal-coordinator-filters {
            right: 240px;
        }

        .modal-status-filters {
            right: 0;
        }
    }


    .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }


    @media (max-width: 980px) {
        .table__container {
            overflow-x: auto;
        }
    }

    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding: 16px;
        padding-bottom: 0;
        th, td {
            padding: 14px;
        }

        &__head {
            
            
            &__row {
                th {
                    // overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-weight: 600;
                    font-size: 12px;
                    text-align: left;

                    &.table__head__row__title {
                        padding-left: 0;
                    }   

                    &.table__head__row__options {
                        padding-right: 0;
                        padding-left: 0;
                    }
                    &.table__head__row__stage {
                    position: relative;

                    .material-icons-outlined{
                        font-size: 14px;
                    }
                    .stage-tooltip{
                        width: 200px;
                        position: absolute;
                        right: -36px;
                        padding: 18px 14px 26px 14px;
                        background: #BDE4E4;
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        border-radius: 10px;
                        text-align: left;
                        font-size: 11px;
                        font-weight: 400;
                        z-index: 100;
                        h4{
                            padding-bottom: 4px;
                            font-size: 13px;
                            font-weight: 700;
                        }
                    }
                }
                }
            }
        }

        &__body {
            tr {
                position: relative;
                td {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 11px;
                    text-align: left;
                    border-bottom: 1px solid #eee;
                    max-width: 170px;

                    &.table__body__row__title {
                        font-weight: 600;
                        font-size: 12px;
                        padding-left: 0;
                    }
                    &.table__body__row__mail, &.table__body__row__phone {
                        padding: 0;
                        //max-width: 200px;
                        div{
                            padding-left: 14px;
                            padding-right: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 6px;
                        }
                        span{
                            max-width: 90%;
                            padding: 14px 0;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        i{
                            font-size: 16px;
                        }
                    }
                    &.table__body__row__phone{ 
                        max-width: 120px !important;
                    }
                    &.table__body__row__status{
                    padding-top: 4px !important;
                    text-align: center;

                        span{
                            display: inline-block;
                            // width: 100px;
                            width: 100%;
                            padding: 4px 16px;
                            border-radius: 50px;
                            font-size: 12px;
                            font-weight: 600;
                            text-align: center;
                            &.--Active, &.--Reactivated{
                                background-color: #EFE2EE;
                                color: #9E5498;
                            }
                            &.--Finished, &.--certificate{
                                color: #009696;
                                background: rgba(189, 228, 228, 0.50);
                            }
                            &.--Inactive{
                                background: rgba(255, 178, 63, 0.15);
                                color: #FFB23F;
                            }
                        }
                    }
                

                    &.table__body__row__options {
                        font-size: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        padding-left: 0;
                        padding-right: 0;
                        width: 28px;
                        div {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                        }   
                    }
                }
            }
        }
    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }


    .unsuscribeUser{
        display: flex;
        flex-direction: column;
        gap: 24px;
        max-width: 460px;
        padding: 0 40px;
        h3{
            font-weight: 700;
            font-size: 16px;
        }
        span{
            font-size: 14px;
        }
        &__buttons{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            gap: 24px;
            button{
                border: 1px solid $green;
                text-align: center;
                width: fit-content;
                display: flex;
                align-items: center;
                gap: 12px;
                border-radius: 999px;
                padding: 12px 18px;
                .material-icons-outlined{
                    font-size: 18px;
                }
                &:first-child{
                    color: $green;
                }
                &:last-child{
                    color: #fff;
                    background-color: $green;
                }
            }
        }
    }
}
.tooltip-icon {
    font-size: 16px;
    position: relative;
    top: 3px;
}
</style>